// extracted by mini-css-extract-plugin
export default {"cardMedia":"iR-z","shopText":"jR-z","videoPlayer":"kR-z","videoContainer":"lR-z"};